<su-headline [hidden]="filledForm" h="h1" skin="primary">{{
  'area_return.title' | translate
}}</su-headline>

<su-card [card]="card" *ngIf="!filledForm">
  <div card-content>
    <formly-form
      [form]="form"
      [fields]="formFields"
      [model]="formModel"
      (modelChange)="onModelChange($event)">
    </formly-form>
  </div>
</su-card>

<su-headline *ngIf="filledForm" h="h1" skin="primary">{{
  'area_return.label__confirmation_title' | translate
}}</su-headline>
<div class="description" *ngIf="filledForm">
  <p
    [innerText]="'relocation.p__info_summary' | translate"
    class="confirm-value"></p>
</div>
<br />
<su-card [card]="cardConfirm" *ngIf="filledForm">
  <div card-content data-debug="form-confirm">
    <ng-container>
      <div class="confirm-container">
        <div>
          <div class="confirm-label">
            <span>
              {{ 'ticket.create.space_request.short_title' | translate }}:
            </span>
          </div>
          <div>
            <span class="confirm-value" *ngIf="formModel['shortTitle']">
              {{ formModel['shortTitle'] }}
            </span>
            <span class="confirm-value" *ngIf="!formModel['shortTitle']">
              --
            </span>
          </div>
        </div>

        <div>
          <div class="confirm-label">
            <span>
              {{ 'ticket.create.space_request.description' | translate }}:
            </span>
          </div>
          <div>
            <span class="confirm-value" *ngIf="formModel['description']">
              {{ formModel['description'] }}
            </span>
            <span class="confirm-value" *ngIf="!formModel['description']">
              --
            </span>
          </div>
        </div>

        <div>
          <div class="confirm-label">
            <span>
              {{ 'area_return.label__organisation_unit' | translate }}:
            </span>
          </div>
          <div>
            <span class="confirm-value" *ngIf="formModel['organisation_unit']">
              {{ formModel['organisation_unit'] }}
            </span>
            <span class="confirm-value" *ngIf="!formModel['organisation_unit']">
              --
            </span>
          </div>
        </div>

        <div>
          <div class="confirm-label">
            <span>
              {{ 'area_return.label__department_similar' | translate }}:
            </span>
          </div>
          <div>
            <span class="confirm-value" *ngIf="formModel['department_similar']">
              {{ formModel['department_similar'] }}
            </span>
            <span
              class="confirm-value"
              *ngIf="!formModel['department_similar']">
              --
            </span>
          </div>
        </div>

        <div>
          <div class="confirm-label">
            <span> {{ 'area_return.label__search' | translate }}: </span>
          </div>
          <div *ngIf="formModel['searchResult']" class="confirm-value">
            <span class="confirm-value">
              {{ formModel['searchResult'].id }},
            </span>
            <span class="confirm-value">
              {{ formModel['searchResult'].streetName }},
            </span>
            <span class="confirm-value">
              {{ formModel['searchResult'].postalCode }}</span
            >
            <span class="confirm-value">
              {{ formModel['searchResult'].city }}</span
            >
          </div>
          <div *ngIf="!formModel['searchResult']">--</div>
        </div>

        <div *ngIf="!isVb; else billingArea">
          <div class="confirm-label">
            <span> {{ 'area_return.label__cost_center' | translate }}: </span>
          </div>
          <div>
            <span class="confirm-value" *ngIf="formModel['costCenterId']">
              {{ formModel['costCenterId'] }}
            </span>
            <span class="confirm-value" *ngIf="!formModel['costCenterId']">
              --
            </span>
          </div>
        </div>

        <ng-template #billingArea>
          <div>
            <div class="confirm-label">
              <span> {{ 'area_return.label__billingArea' | translate }}: </span>
            </div>
            <div>
              <span class="confirm-value" *ngIf="formModel['billingArea']">
                {{ formModel['billingArea'] }}
              </span>
              <span class="confirm-value" *ngIf="!formModel['billingArea']">
                --
              </span>
            </div>
          </div>
        </ng-template>

        <div>
          <div class="confirm-label">
            <span> {{ 'area_return.label__desired_date' | translate }}: </span>
          </div>
          <div>
            <span class="confirm-value" *ngIf="formModel['desiredDate']">
              {{ formModel['desiredDate'] | date: 'dd.MM.yyyy' }}
            </span>
            <span class="confirm-value" *ngIf="!formModel['desiredDate']">
              --
            </span>
          </div>
        </div>

        <div>
          <div class="confirm-label">
            <span>
              {{ 'area_return.summary.costcenter_society' | translate }}:
            </span>
          </div>
          <div>
            <span class="confirm-value" *ngIf="formModel['companyCost']">
              {{ formModel['companyCost'] }}
            </span>
            <span class="confirm-value" *ngIf="!formModel['companyCost']">
              --
            </span>
          </div>
        </div>

        <div>
          <div class="confirm-label">
            <span> {{ 'area_return.label__selected_uses' | translate }}: </span>
          </div>
          <ng-container *ngIf="!isVb; else selectedVbs">
            <div
              *ngIf="(selectedRowsSubject$ | async)?.length > 0; else noData">
              <div *ngFor="let usage of selectedRowsSubject$ | async">
                <div class="confirm-value">
                  <span>
                    {{ 'area_return.label__room' | translate }}:
                    {{ usage.roomName }}
                  </span>
                  <span *ngIf="usage.workspaceName">
                    <br />
                    {{ 'area_return.label__workSpace' | translate }}:
                    {{ usage.workspaceName }}
                  </span>
                  <span *ngIf="!usage.workspaceName">
                    <br />
                    {{ 'area_return.label__m2' | translate }}:
                    {{ usage.area }} m²
                  </span>
                  <br />
                  <span>
                    {{ 'area_return.label__endOfUse' | translate }}:
                    {{
                      isValidDate(usage.usageUntil?.toString()) === true
                        ? (usage.usageUntil | date: 'dd.MM.yyyy')
                        : (formModel['desiredDate'] | date: 'dd.MM.yyyy')
                    }}
                  </span>
                  <br />
                  <span>
                    {{ 'area_return.label__validUntil' | translate }}:
                    {{ usage.originalUsageUntil }}
                  </span>
                  <br />
                  <span>
                    {{ 'area_return.label__costCenter' | translate }}:
                    {{ usage.costCenter }}
                  </span>
                  <br />
                </div>
                <hr />
              </div>
            </div>
          </ng-container>
          <ng-template #selectedVbs>
            <div
              *ngIf="(vbSelectedRowsSubject$ | async)?.length > 0; else noData">
              <div *ngFor="let usage of vbSelectedRowsSubject$ | async">
                <div class="confirm-value">
                  <span>
                    {{ 'area_return.label__endOfUse' | translate }}:
                    {{
                      isValidDate(usage.requestedUsageUntil?.toString()) ===
                      true
                        ? (usage.requestedUsageUntil | date: 'dd.MM.yyyy')
                        : (formModel['desiredDate'] | date: 'dd.MM.yyyy')
                    }}
                  </span>
                  <br />
                  <span>
                    {{ 'area_return.label__costCenter' | translate }}:
                    {{ usage.costCenterId }}
                  </span>
                  <br />
                  <span>
                    {{ 'area_return.label__quantity_current' | translate }}:
                    {{ usage.numberOfWorkspaces }}
                  </span>
                  <br />
                  <span>
                    {{ 'area_return.label__quantity_selection' | translate }}:
                    {{ usage.numberOfWorkspacesSelection }}
                  </span>
                  <br />
                  <span>
                    {{ 'area_return.label__validUntil' | translate }}:
                    {{ usage.usageUntil | date: 'dd.MM.yyyy' }}
                  </span>
                  <br />
                </div>
                <hr />
              </div>
            </div>
          </ng-template>
          <ng-template #noData>
            <span class="confirm-value">--</span>
          </ng-template>
        </div>

        <div>
          <div class="confirm-label">
            <span>
              {{ 'ticket.create.headline__search_creator' | translate }}:
            </span>
          </div>
          <div>
            <span
              class="confirm-value"
              *ngIf="formModel['searchContact']?.searchResult?.id">
              <span *ngIf="formModel['searchContact'].searchResult.fullName">
                {{ formModel['searchContact'].searchResult.fullName }},</span
              >
              <span *ngIf="formModel['searchContact'].searchResult.phone">
                {{ formModel['searchContact'].searchResult.phone }},</span
              >
              <span *ngIf="formModel['searchContact'].searchResult.email">
                {{ formModel['searchContact'].searchResult.email }},</span
              >
              <span *ngIf="formModel['searchContact'].searchResult.company">
                {{ formModel['searchContact'].searchResult.company }},</span
              >
              {{ formModel['searchContact'].searchResult.orgUnit }}
            </span>
            <span
              class="confirm-value"
              *ngIf="!formModel['searchContact']?.searchResult?.id">
              --
            </span>
          </div>
        </div>

        <div>
          <div class="confirm-label">
            <span>{{ 'ticket.create.label__processor' | translate }}:</span>
          </div>
          <div>
            <span
              class="confirm-value"
              *ngIf="formModel['contactPerson']?.searchResult?.id">
              <span *ngIf="formModel['contactPerson'].searchResult.fullName">
                {{ formModel['contactPerson'].searchResult.fullName }},</span
              >
              <span *ngIf="formModel['contactPerson'].searchResult.phone">
                {{ formModel['contactPerson'].searchResult.phone }},</span
              >
              <span *ngIf="formModel['contactPerson'].searchResult.email">
                {{ formModel['contactPerson'].searchResult.email }},</span
              >
              <span *ngIf="formModel['contactPerson'].searchResult.company">
                {{ formModel['contactPerson'].searchResult.company }},</span
              >
              {{ formModel['contactPerson'].searchResult.orgUnit }}
            </span>
            <span
              class="confirm-value"
              *ngIf="!formModel['contactPerson']?.searchResult?.id">
              --
            </span>
          </div>
        </div>

        <div>
          <div class="confirm-label">
            <span>
              {{ 'ticket.create.label__notification' | translate }}:
            </span>
          </div>
          <div>
            <span class="confirm-value" *ngIf="formModel['ccemail']">
              {{ formModel['ccemail'] }}
            </span>
            <span class="confirm-value" *ngIf="!formModel['ccemail']">
              --
            </span>
          </div>
        </div>
      </div>
    </ng-container>

    <form (ngSubmit)="submit()">
      <div class="confirm-buttons">
        <su-button
          [skin]="'primary'"
          [icon]="'arrow-left'"
          [label]="'ticket.create.confirm.button__back_to_edit' | translate"
          (onClick)="pressBackToEdit()">
        </su-button>
        <su-button
          id="buttonSendInConfirmForm"
          type="submit"
          [skin]="'accent'"
          [icon]="'paper-plane'"
          [label]="'ticket.create.confirm.button__send' | translate"
          [disabled]="isSubmitted">
        </su-button>
      </div>
    </form>
  </div>
</su-card>

<app-cell-templates #sharedTemplates></app-cell-templates>

<ng-container *ngTemplateOutlet="sharedTemplates.selectionCellTemplateRef">
</ng-container>

<ng-template #datepickerUsageUntilCellTemplate let-row let-column="column">
  <div
    style="
      display: flex;
      justify-content: space-around;
      align-items: baseline;
      margin-top: 10px;
      height: 70px;
    ">
    <mat-form-field style="width: 160px">
      <mat-label>{{ 'area_return.choose_date' | translate }}</mat-label>
      <input
        matInput
        [matDatepicker]="picker"
        [(ngModel)]="row.usageUntil"
        (ngModelChange)="onDateChange(row, $event)"
        [min]="getNextAvailableQuarterEnd()"
        [matDatepickerFilter]="dateFilter" />
      <mat-datepicker-toggle
        matIconSuffix
        [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
  </div>
</ng-template>

<ng-template
  #datepickerRequestedUsageUntilCellTemplate
  let-row
  let-column="column">
  <div
    style="
      display: flex;
      justify-content: space-around;
      align-items: baseline;
      margin-top: 10px;
      height: 70px;
    ">
    <mat-form-field style="width: 160px">
      <mat-label>{{ 'area_return.choose_date' | translate }}</mat-label>
      <input
        matInput
        [matDatepicker]="picker"
        [(ngModel)]="row.requestedUsageUntil"
        (ngModelChange)="onDateChangeVb(row, $event)"
        [min]="getNextAvailableQuarterEnd()"
        [matDatepickerFilter]="dateFilter" />
      <mat-datepicker-toggle
        matIconSuffix
        [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
  </div>
</ng-template>

<ng-template #deleteCellTemplate let-row let-column="column">
  <su-button
    (onClick)="onDeleteSelectedUsage(row, isVb)"
    skin="secondary"
    icon="trash"
    [ariaLabel]="'form.delete' | translate"></su-button>
</ng-template>

<ng-template #inputCellTemplate let-row let-column="column">
  <mat-form-field
    style="width: 160px"
    [ngClass]="
      !(
        workspaceInput.invalid &&
        (workspaceInput.errors?.['max'] || workspaceInput.errors?.['min'])
      )
        ? 'custom-input'
        : ''
    ">
    <input
      matInput
      type="number"
      [(ngModel)]="row.numberOfWorkspacesSelection"
      [min]="1"
      [max]="row.numberOfWorkspaces"
      #workspaceInput="ngModel"
      required />
    <mat-error *ngIf="workspaceInput.invalid && workspaceInput.errors?.['max']">
      Maximale Anzahl: {{ row.numberOfWorkspaces }}
    </mat-error>
    <mat-error *ngIf="workspaceInput.invalid && workspaceInput.errors?.['min']">
      Minimale Anzahl: {{ 1 }}
    </mat-error>
  </mat-form-field>
</ng-template>

<app-spinner-overlay
  [show]="loading"
  [label]="loadingMessage"></app-spinner-overlay>
